import { QueryParams, SubscriptionPlan } from '@/model';
import apiClient from '../api/apiClient';
import { buildApiUrl } from '../utils';
import { GetSubscriptionPlansResponse } from '../response/subscription-plan';
import { CreateSubscriptionPlanPlayload } from '../request/subscription-plan';

export class SubscriptionPlanService {
  static getSubscriptionPlans(params?: QueryParams) {
    return apiClient.get<GetSubscriptionPlansResponse>(buildApiUrl('/api/v1/administrator/subscription-plans'), params);
  }

  static getSubscriptionPlanById(id: string, params?: QueryParams) {
    return apiClient.get<SubscriptionPlan>(buildApiUrl('/api/v1/administrator/subscription-plans/:id', { id }), params);
  }

  static createSubscriptionPlan(payload: CreateSubscriptionPlanPlayload) {
    return apiClient.post<void>(buildApiUrl('/api/v1/administrator/subscription-plans'), payload);
  }

  static updateSubscriptionPlan(id: string, payload: CreateSubscriptionPlanPlayload) {
    return apiClient.post<void>(buildApiUrl('/api/v1/administrator/subscription-plans/:id', { id }), payload);
  }
}
